import React from 'react';
import classNames from 'classnames';
import InputTransient from '../../components/Utils/InputTransient';
import { DATABASE_ADD_ROW } from '../../../../types/AnalyticsTypes';
export default React.memo(function TextField(props) {
  var database = props.database,
      recordKey = props.recordKey,
      columnKey = props.columnKey,
      isFocused = props.isFocused,
      value = props.value,
      store = props.store,
      _props$plugins = props.plugins,
      plugins = _props$plugins === void 0 ? [] : _props$plugins,
      _props$format = props.format,
      format = _props$format === void 0 ? function (x) {
    return x;
  } : _props$format,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className;
  var onEnter = React.useCallback(function (event) {
    event.preventDefault();
    event.stopPropagation();

    if (!database.getRecordAfter(recordKey)) {
      database.insertRecord() // If on the last record, create a new one to activate
      .command('track', DATABASE_ADD_ROW, {
        source: 'Pressed enter'
      });
    }

    database.activateRecordAfter();
  }, [database, recordKey]);
  var onChange = React.useCallback(function (text) {
    store.reset();
    database.mergeFieldData(recordKey, columnKey, {
      text: format(text)
    });
  }, [database, columnKey, recordKey, store, format]);
  return React.createElement(InputTransient, {
    plugins: plugins,
    className: classNames('flexbox-grow', 'shade-05', 'padding-vertical-small padding-horizontal-normal', className),
    autoFocus: isFocused,
    placeholder: "",
    value: value,
    readOnly: database.readOnly || !isFocused,
    onEnter: onEnter,
    onChange: onChange
  });
});